// extracted by mini-css-extract-plugin
export default {"states":"ApplicationList_states__ziKMn","tabNav":"ApplicationList_tabNav__Td64t","loading":"ApplicationList_loading__rLL4i"};